import type { SVGProps } from 'react';
const SvgAddRoad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#add_road_svg__a)">
      <path d="M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3ZM20 4h-2v9h2V4ZM6 4H4v16h2V4ZM13 4h-2v4h2V4ZM13 10h-2v4h2v-4ZM13 16h-2v4h2v-4Z" />
    </g>
    <defs>
      <clipPath id="add_road_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAddRoad;
